export type GlCategoryYearRow = {
  name: string;
  value: number;
  count: number;
  byYear: Record<string, number>;
  countByYear: Record<string, number>;
};

export const GL_YEAR_ALL = 'ALL';

export function isAllGlYear(year: string | null | undefined): boolean {
  const value = String(year || '').trim().toUpperCase();
  return !value || value === GL_YEAR_ALL;
}

export function yearsForGlCategoryTables(
  selectedYear: string,
  txYears: Array<string | null | undefined>,
  availableYears: string[] = []
): string[] {
  if (!isAllGlYear(selectedYear)) {
    const year = String(selectedYear || '').trim();
    return year ? [year] : [];
  }
  const fromTx = Array.from(
    new Set(
      txYears
        .map((year) => String(year || '').trim())
        .filter((year) => /^\d{4}$/.test(year))
    )
  )
    .sort()
    .reverse();
  if (fromTx.length) return fromTx;
  return [...availableYears]
    .map((year) => String(year || '').trim())
    .filter((year) => /^\d{4}$/.test(year))
    .sort()
    .reverse();
}

export function latestGlYear(years: string[]): string {
  return [...years]
    .map((year) => String(year || '').trim())
    .filter((year) => /^\d{4}$/.test(year))
    .sort()
    .reverse()[0] || '';
}

export function buildGlCategoryChartRows(
  categories: Array<{
    name?: string;
    value?: number;
    count?: number;
    byYear?: Record<string, number>;
    countByYear?: Record<string, number>;
  }>
): GlCategoryYearRow[] {
  return categories
    .map((row) => {
      const byYear = { ...(row.byYear || {}) };
      const countByYear = { ...(row.countByYear || {}) };
      const value =
        Number(row.value) ||
        Object.values(byYear).reduce((sum, amount) => sum + Number(amount || 0), 0);
      const count =
        Number(row.count) ||
        Object.values(countByYear).reduce((sum, amount) => sum + Number(amount || 0), 0);
      return {
        name: String(row.name || '').trim() || 'Uncategorized',
        value,
        count,
        byYear,
        countByYear,
      };
    })
    .filter((row) => row.value > 0)
    .sort((left, right) => right.value - left.value || left.name.localeCompare(right.name));
}
